import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import tagModel from "@/models/tag/tag-list";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function usePermissionTab(props) {
  const { openErrorModal, openDefaultErrorModal } = useValidationModal();

  const { fetchTagList } = tagModel();

  const { fetchDetailSurveyModel } = surveyModel();

  const vm = getCurrentInstance().proxy;

  const permissionData = reactive({
    headerName: "กรุณาตั้งค่าสิทธิ์การเข้าถึงแบบสำรวจ",
    descTag: "ได้สิทธิ์ใช้งานแบบสำรวจนี้ได้",
    descVisibility: "ที่มองเห็นแบบสำรวจนี้ได้",
    descPermission: "ที่ได้สิทธิ์ใช้งานแบบสำรวจนี้ได้",
    surveyGroupId: null,
    selected: 1,
    visibility: [],
    permission: [],
    duplicate: false,
    limitPlayer: false,
    numberPlayer: 0,
    point: 0,
    isEdit: true,
  });

  const tagOption = reactive({
    visibilityTagOption: [],
    permissionOption: [],
    tagAll: [],
  });

  const fetchTagPermissionList = () => {
    // window.$loading(true);
    store
      .dispatch("api/apiRequest", fetchTagList)
      .then((resp) => {
        if (resp.data.tag_list.length > 0) {
          tagOption.visibilityTagOption = resp.data.tag_list.map((obj) => ({
            seq: obj.seq,
            label: obj.tag,
          }));
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        // window.$loading(false);
      });
  };

  const onSelectTagVisibility = (TagVisibility) => {
    tagOption.permissionOption = TagVisibility;

    if (tagOption.permissionOption.length != permissionData.permission.length) {
      permissionData.permission = tagOption.permissionOption.filter((o) => {
        return permissionData.permission.indexOf(o) > -1;
      });
    } else {
      permissionData.permission = tagOption.permissionOption.filter((o) => {
        return permissionData.permission.includes(o);
      });
    }
  };

  const onInputDuplicateTag = (isDuplicate) => {
    if (isDuplicate) {
      permissionData.permission = permissionData.visibility;
    } else {
      permissionData.permission = "";
    }
  };

  const onUpdateLimit = (limit) => {
    permissionData.numberPlayer = limit || 0;
  };

  const onChangePoint = (isLimit) => {
    if (!isLimit) {
      permissionData.numberPlayer = 0;
    }
  };

  const fetchDetailSurvey = () => {
    window.$loading(true);
    fetchDetailSurveyModel.payload.Survey_GroupId =
      permissionData.surveyGroupId;

    store
      .dispatch("api/apiRequest", fetchDetailSurveyModel)
      .then((response) => {
        const responseInformation = response.data.resp.infomation;
        const responsePermission = response.data.resp.permission;

        permissionData.limitPlayer = responseInformation.islimit;
        permissionData.numberPlayer = responseInformation.limit;
        permissionData.isEdit = responseInformation.isedit;

        permissionData.visibility = [];
        permissionData.permission = [];
        responsePermission.map((o) => {
          if (o.tag_type == 1) {
            permissionData.visibility.push(o.tag_name);
          } else if (o.tag_type == 2) {
            permissionData.permission.push(o.tag_name);
          }
        });

        tagOption.permissionOption = permissionData.visibility;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  watch(
    permissionData,
    () => {
      vm.$emit("onSetPermissionData", permissionData);
    },
    { deep: true }
  );

  watch(
    () => props,
    () => {
      if (props?.isEdit) fetchDetailSurvey();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    if (router.currentRoute.query.surveyGroupId) {
      permissionData.surveyGroupId = parseInt(
        router.currentRoute.query.surveyGroupId
      );
    } else {
      permissionData.surveyGroupId = parseInt(router.currentRoute.params.ref);
    }

    if (permissionData.surveyGroupId) {
      fetchDetailSurvey();
    }
    fetchTagPermissionList();
    vm.$emit("onSetPermissionData", permissionData);
  });

  return {
    permissionData,
    tagOption,
    onSelectTagVisibility,
    onInputDuplicateTag,

    onUpdateLimit,
    onChangePoint,
  };
}
